<template>
    <div>
        <my-info :info="info" />

        <div v-for="(cate, index) in cates" :key="index">
            <div class="weui-cells__title">{{cate.title}}</div>
            <div class="weui-cells">
                <router-link
                    :to="getRoute(item)"
                    class="weui-cell weui-cell_access"
                    v-for="(item, index) in cate.items"
                    :key="index"
                >
                    <div class="weui-cell__bd">
                        <p>{{item.title}}</p>
                    </div>
                    <div class="weui-cell__ft">{{item.status}}</div>
                </router-link>
            </div>
        </div>

        <br />
    </div>
</template>

<script>
import MyInfo from "./components/MyInfo";

export default {
    name: "HomeMe",
    data: function() {
        return {
            info: null,
            cates: null
        };
    },
    created() {
        // 组件创建完后获取数据，
        // 此时 data 已经被 observed 了
        this.fetchData();
    },
    watch: {
        // 如果路由有变化，会再次执行该方法
        $route: "fetchData"
    },
    methods: {
        fetchData: function() {
            this.$store.commit("loading");
            this.$axios.get("home/me").then(response => {
                this.cates = response.data.cates;

                var info = {
                    button: []
                };
                info.avatar = response.data.info.avatar;
                info.name = response.data.info.username;
                info.extra = [response.data.info.role_name];
                if (!!response.data.info.expired) {
                    info.extra.push(response.data.info.expired);
                }
                if (!!response.data.info.show_renew) {
                    info.button.push("renew");
                }
                if (!!response.data.info.show_join) {
                    info.button.push("join");
                }
                this.info = info;

                this.$store.commit("loading", false);
            });
        },
        getRoute: function(item) {
            if (!!item.url) {
                return item.url;
            }

            return {
                path: item.route
            };
        }
    },
    components: {
        MyInfo
    }
};
</script>
